module.exports = __webpack_public_path__ + "static/media/mouse-line.55b4a98b.svg";